import { observer } from 'mobx-react-lite';
import React from 'react';

import { Icon, IconLinkUn, IconArrowBigDotsRight } from '@flixbus/honeycomb-icons-react';

import { rideDetailsStore } from 'pages/RideDetails/RideDetailsStore';

import styles from './styles.module.css';

const UnBatchSegmentController = observer(({ breakBatchData }) => {
	const { breakBatchByStation } = rideDetailsStore;
	return (
		<div className={styles.batch}>
			<div
				onClick={() => {
					breakBatchByStation(breakBatchData);
				}}
				className={styles.link}
			>
				<Icon InlineIcon={IconLinkUn} />
				<div className={styles.hoverEffect}>
					<div className={styles.hoverline} />
					<div className={`${styles.arrow}`}>
						<Icon extraClasses={styles.left} InlineIcon={IconArrowBigDotsRight} />
						<Icon InlineIcon={IconArrowBigDotsRight} />
					</div>
				</div>
			</div>
		</div>
	);
});

export default UnBatchSegmentController;
